import {
    handle as publicHandle,
    loader,
    default as ProfessionalNetworkRoute,
} from '~/routes/_app.professional.$urlSegment.partners.$';
import type { PreviewDisabledFeatures } from '@modules/root/hook/use-is-disabled-in-preview';
import type { APHandle } from '~/modules/root';

const disabledInPreview: PreviewDisabledFeatures = {
    featured_tile_links: false,
};

// NOTE: this was previously exported as `handl`, so disabledInPreview never
// reached the route. Kept as-is under the typo'd name to avoid changing the
// Network preview's tile-link behaviour in a layout change; see BC-4505.
export const handl: APHandle = {
    disabledInPreview,
};

export const handle: APHandle = publicHandle;

export { loader };
export default ProfessionalNetworkRoute;
